import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Request } from '../../services/request.service';
import { DialogComponent, DialogConfig } from '../dialog/dialog.component';

@Component({
  selector: 'app-request-detail',
  standalone: true,
  imports: [CommonModule, DialogComponent],
  templateUrl: './request-detail.component.html',
  styleUrls: ['./request-detail.component.scss']
})
export class RequestDetailComponent {
  @Input() request: Request | null = null;
  @Input() isSystemOpen: boolean = true;
  /** Sistem meşgul mü (busy)? Meşgulken de işlem engellenecek */
  @Input() isSystemBusy: boolean = false;
  @Input() isLoading: boolean = false;
  @Output() quickResponse = new EventEmitter<number>();

  showDialog: boolean = false;
  dialogConfig: DialogConfig = {
    title: '',
    message: '',
    type: 'warning'
  };

  onQuickResponse(minutes: number): void {
    // Sistem kapalıysa, meşgulse veya yükleniyorsa işlem yapma
    if (!this.isSystemOpen || this.isSystemBusy || this.isLoading) {
      if (!this.isSystemOpen) {
        this.showWarningDialog('Sistem kapalı olduğu için talep onaylama mümkün değildir.');
      } else if (this.isSystemBusy) {
        this.showWarningDialog('Sistem meşgul modunda olduğu için talep onaylama mümkün değildir.');
      }
      return;
    }
    this.quickResponse.emit(minutes);
  }

  formatTime(dateString: string | undefined): string {
    if (!dateString) return '-';

    try {
      const date = new Date(dateString);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    } catch {
      return '-';
    }
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return '-';

    try {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    } catch {
      return '-';
    }
  }

  showWarningDialog(message: string): void {
    this.dialogConfig = {
      title: 'Uyarı',
      message: message,
      type: 'warning',
      confirmText: 'Tamam',
      showCancel: false
    };
    this.showDialog = true;
  }

  onDialogClose(): void {
    this.showDialog = false;
  }

  getPhoneNumber(): string {
    if (!this.request) return '';
    return this.request.phone_number;
  }

  getLocation(): string {
    if (!this.request) return '';
    return this.request.location_details || this.request.location;
  }

  hasAutomaticMessageSent(): boolean {
    if (!this.request) return false;
    return this.request.status === 'auto_responded';
  }
}

